export default __webpack_public_path__ + "static/media/add.98910c23.svg";